<h1 mat-dialog-title>{{ data?.modalTitle }}
  <span [ngClass]="{ 'd-none': !data?.property?.name }"> - {{ data?.property?.name }}</span>
</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div class="row">
    <div class="side-menu col-12 col-md-5 col-lg-4">
      <ng-container *ngIf="mappingIndex && mappingIndex.length">
        <mat-accordion class="mapping-index">
          <ng-container *ngFor="let item of mappingIndex; let i = index;">

            <div *ngIf="checkVisibility(item)">
              <div class="custom-expansion-panel" [ngClass]="{'openFirstLevel': item.expanded === true}">
                <!-- Icon and title accordion -->
                <a href="javascript:;" class="header-link-wrapper" (click)="onPanelClicked(item, i)">
                  <div class="custom-expansion-panel-header">
                    <div class="custom-expansion-panel-toggle" [ngClass]="{'openFirstLevel': item.expanded === true}">
                    </div>
                    <div class="custom-expansion-panel-header-content">
                      <div class="custom-expansion-panel-header-icon-wrapper" *ngIf="item.icon === ''">
                        <mat-icon fontSet="fal" fontIcon="fa-folder" class="mr-3 fa-fw"
                          [ngClass]="{'d-none': item.expanded === true}"></mat-icon>
                        <mat-icon fontSet="fal" fontIcon="fa-folder-open" class="mr-3 fa-fw"
                          [ngClass]="{'d-none': item.expanded === false}"></mat-icon>
                      </div>
                      <div class="custom-expansion-panel-header-icon-wrapper" *ngIf="item.icon !== ''">
                        <div *ngIf="item.title !== 'properties.structures.amianto'">
                          <mat-icon fontSet="fal" fontIcon="{{ item.icon }}" class="mr-3 fa-fw"></mat-icon>
                        </div>
                        <div *ngIf="item.title === 'properties.structures.amianto'">
                          <svg xmlns="http://www.w3.org/2000/svg" width="54px" height="54px">
                            <text font-weight="50" fill="#ec9451" x="19" y="34" font-size="37">a</text>
                          </svg>
                        </div>
                      </div>
                      <strong>{{ item.title | translate  }}</strong>
                    </div>
                  </div>
                </a>

                <div class="custom-expansion-panel-content">
                  <div *ngIf="item.content.length">
                    <div *ngFor="let subItem of item.content">

                      <ng-container *ngIf="subItem.key === 'anagrafica'">
                        <div class="element no-children-element" [ngClass]="{'active': subItem.active}">
                          <a (click)="activateSection(subItem.section)">
                            <span *ngIf="lang === 'it' && subItem.translation">{{ subItem.translation.it }}</span>
                            <span *ngIf="lang === 'en' && subItem.translation">{{ subItem.translation.en }}</span>
                          </a>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="!subItem.hidden && subItem.type === 'link' && subItem.key !== 'anagrafica'">
                        <div matBadge="{{ getChildren(subItem.key).length }}" matBadgePosition="above after"
                          matBadgeColor="primary" *ngIf="subItem.key !== 'anagrafica'">
                        </div>
                        <div class="custom-expansion-panel-child" *ngIf="getChildren(subItem.key).length">
                          <a href="javascript:;" class="header-link-wrapper"
                            (click)="subItem.expanded = !subItem.expanded">
                            <div class="custom-expansion-panel-header-second">
                              <div class="custom-expansion-panel-toggle-child"
                                [ngClass]="{'openSecondLevel': subItem.expanded === true}"></div>
                              <div class="custom-expansion-panel-header-content-second">
                                <span *ngIf="lang === 'it' && subItem.translation">{{ subItem.translation.it }}</span>
                                <span *ngIf="lang === 'en' && subItem.translation">{{ subItem.translation.en }}</span>
                              </div>
                            </div>
                          </a>

                          <ul class="custom-expansion-panel-content-list"
                            [ngClass]="{'openSecondLevel': subItem.expanded === true}">
                            <li *ngFor="let subSubitem of getChildren(subItem.key)"
                              [ngClass]="{'active': (model._id === subSubitem._id && subSubitem.active)}" class="element">
                              <a *ngIf="subSubitem.active" (click)="onFormItemClick(subItem.section, subSubitem)">
                                <span *ngIf="subItem.key === 'dipendenti'">{{ subSubitem.nome }}
                                  {{ subSubitem.cognome }} </span>
                                <span *ngIf="subItem.key === 'impresePulizia'">{{ subSubitem.nomeDitta }}</span>
                                <!-- <span
                                  *ngIf="subItem.key === 'estintori'">{{ 'properties.structures.estintori' | translate }}</span> -->
                                <span
                                  *ngIf="subItem.key === 'amianto'">{{ 'properties.structures.amianto' | translate }}</span>
                                <!-- <span
                                  *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia' && subItem.key !== 'estintori'">{{ subSubitem.nome }}</span> -->
                                <span
                                  *ngIf="subItem.key !== 'dipendenti' && subItem.key !== 'impresePulizia'">{{ subSubitem.nome }}</span>
                              </a>
                            </li>
                          </ul>
                        </div>

                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </ng-container>
        </mat-accordion>
      </ng-container>
    </div> <!-- /.col -->

    <div class="col-12 col-md-7 col-lg-8" [ngClass]="{ 'side-form-loading': formIsLoading }">
      <app-card-spinner [visible]="formIsLoading" type="zero"></app-card-spinner>
      <div class="alert alert-info" *ngIf="!formActiveSection">
        <strong>{{ 'properties.structures.warning' | translate }}</strong> <br>
        <p class="mb-0">
          {{ 'properties.structures.selectElem' | translate }}
        </p>
      </div> <!-- /.alert -->

      <div *ngIf="formActiveSection && formActiveSubitemId">
        <div class="row">
          <div class="col-10">
            <h4>
              {{ activeItem?.title | translate }} {{ model?.nome ? '- ' + model.nome : '' }}
            </h4>
          </div>
        </div>

        <hr>

        <div class="form-wrapper mt-3 py-3" *ngIf="!formIsLoading">
          <form [formGroup]="form">
            <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
          </form>
        </div> <!-- /.form-wrapper -->
      </div>
    </div>
  </div>
</mat-dialog-content>